// for moneysukh.com

export const ApiUrlDomain="https://www.moneysukh.com";
export const ApiUrlDomainBlogImg="https://www.moneysukh.com/pdf/BlogImages";


// for alpha.moneysukh.com
// export const ApiUrlDomain="http://192.168.100.70:5010";

// export const ApiUrlDomain="https://alpha.moneysukh.com";
//  export const ApiUrlDomainBlogImg="http://192.168.100.70:5010/pdf/BlogImages";